import { PlannerBase }   from "../../planner_base";
import { Global, LineCalendarCell, LineSelectedCell } from "../model";
import watch from "redux-watch";
import isEqual from 'is-equal';


class LineUiIndCell extends PlannerBase {
  isShow: boolean = false;
  left: number = 0;
  init(){
    super.init();
    this.watchPlannerData('selectedCell', (newVal: any, oldVal: any, objectPath: string) => { this.onChangeSelectedData(newVal, oldVal, objectPath)});
  }
  onChangeSelectedData(selectedCell: LineSelectedCell, oldVal: any, objectPath: string){
    if(selectedCell != null && selectedCell.lineId == this.opts.id){
      this.show(selectedCell);
    } else {
      this.hide();
    }
  }
  hide(){
    if(!this.isShow){ return; }
    this.isShow = false;
    this.left = 0;
    this.update();
  }
  show(selectedCell: LineSelectedCell){
    this.isShow = true;
    this.left = selectedCell.cell.index * Global.cellWidth;
    this.update();
  }
}
riot.mixin('orders.planner.line-ui.ind-cell', LineUiIndCell as riot.TagMixin)
